module.exports = __webpack_public_path__ + "img/35.fixed_broken_toilet.73c66162.svg";